export const TYPE_PDF = 'Pdf';
export const TYPE_DOCX = 'Docx';

export const EDITION_FACTURE = 'Facture';
export const EDITION_COMMANDE = 'Commande';
export const EDITION_DEVIS = 'Devis';
export const EDITION_REMISE_BANCAIRE = 'RemiseBancaire';
export const EDITION_RELANCE = 'Relance';
export const EDITION_ORDRE_TRAVAIL = 'OrdreTravail';
export const EDITION_PRODUIT_RESEAU = 'ProduitReseau';
export const EDITION_LOT_PAIEMENT_CHEQUE_MANUEL = 'LotPaiementChequeManuel';
export const EDITION_LOT_PAIEMENT_LETTRE_CHEQUE = 'LotPaiementLettreCheque';
export const EDITION_LOT_PAIEMENT_VIREMENT = 'LotPaiementVirement';
export const EDITION_LOT_PAIEMENT_JUSTIF_POSE = 'JustifPose';
export const EDITION_LOT_PAIEMENT_DOSSIER_TEMPO = 'DossierTempo';
export const EDITION_ETIQUETTE = 'EtiquetteFacture';

export const EDITION_LISTE_TYPES = [
  { key: EDITION_FACTURE, libelle: 'addEditParametrageEdition.editionListe.facture' },
  { key: EDITION_COMMANDE, libelle: 'addEditParametrageEdition.editionListe.commande' },
  { key: EDITION_DEVIS, libelle: 'addEditParametrageEdition.editionListe.devis' },
  { key: EDITION_REMISE_BANCAIRE, libelle: 'addEditParametrageEdition.editionListe.remiseBancaire' },
  { key: EDITION_RELANCE, libelle: 'addEditParametrageEdition.editionListe.relance' },
  { key: EDITION_ORDRE_TRAVAIL, libelle: 'addEditParametrageEdition.editionListe.ordreTravail' },
  { key: EDITION_PRODUIT_RESEAU, libelle: 'addEditParametrageEdition.editionListe.produitReseau' },
  { key: EDITION_LOT_PAIEMENT_CHEQUE_MANUEL, libelle: 'addEditParametrageEdition.editionListe.lotPaiementChequeManuel' },
  { key: EDITION_LOT_PAIEMENT_LETTRE_CHEQUE, libelle: 'addEditParametrageEdition.editionListe.lotPaiementLettreCheque' },
  { key: EDITION_LOT_PAIEMENT_VIREMENT, libelle: 'addEditParametrageEdition.editionListe.lotPaiementVirement' },
  { key: EDITION_LOT_PAIEMENT_JUSTIF_POSE, libelle: 'addEditParametrageEdition.editionListe.justifPose' },
  { key: EDITION_LOT_PAIEMENT_DOSSIER_TEMPO, libelle: 'addEditParametrageEdition.editionListe.dossierTempo' },
  { key: EDITION_ETIQUETTE, libelle: 'addEditParametrageEdition.editionListe.etiquette' },
];
